import axios from 'axios';

export default async function loadConfig() {
    try {
        const response = await axios.get('/vuetify/config.json?nocache=' + Date.now());
        if (typeof response.data !== 'object') {
            throw new Error('Invalid config file');
        }
        window.config = response.data;
    } catch {
        window.config = {
            "APP_ENV": import.meta.env.VITE_APP_ENV || 'production',
            "BASE_URL": import.meta.env.VITE_APP_BASE_URL,
            "BACKOFFICE_URL": import.meta.env.VITE_APP_BO_URL,
            "WEBSITE_URL": import.meta.env.VITE_APP_WEBSITE_URL,
            "MINE_333TRAVEL_URL": import.meta.env.VITE_APP_MINE_333TRAVEL_URL,
            "MINE_TRAVELPLATINUM_URL": import.meta.env.VITE_APP_MINE_TRAVELPLATINUM_URL,
            "AGENTS_URL": import.meta.env.VITE_APP_AGENTS_URL,
            "PLATINUM_URL": import.meta.env.VITE_APP_PLATINUM_URL,
            "SOCKETIO_URL": import.meta.env.VITE_APP_SOCKETIO_URL,
            "TRAVALCO_URL": import.meta.env.VITE_APP_TRAVALCO_URL,
            "JONVIEW_URL": import.meta.env.VITE_APP_JONVIEW_URL,
            "TOMTOM_API_KEY": import.meta.env.VITE_APP_TOMTOM_API_KEY,
            "SENTRY_DSN": import.meta.env.VITE_APP_SENTRY_DSN
        };
    }
}
